import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DashboardViewType } from '@shared/enums/dashboard-view-type';
import { RouteData } from '@shared/enums/route-data';
import { ViewCloseGuard } from '@shared/guards/view-close.guard';

import { HomeDashboardComponent } from './home-dashboard.component';

const routes: Routes = [
  {
    path: '',
    component: HomeDashboardComponent,
    canDeactivate: [ViewCloseGuard],
    data: {
      [RouteData.DASHBOARD_VIEW_TYPE]: DashboardViewType.NONE,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomeDashboardRoutingModule {}
